import decorativo from '../../../Assets/img/shape13.svg'
import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos'
import PropuestaValor from '../Components/PropuestaValor'
import Asesoramiento from '../Components/Asesoramiento'
import Formulario from '../Components/Formulario';
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from "../Components/Navbar"
import { useConfig } from '../../../context/ConfigContext'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

export const VidaCorporativa = () => {

    const { config } = useConfig();
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);

    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle: "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar
                rubro='auto'
            />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro de Vida Corporativa'
                    url='#formulario'
                    icon='#icon-seg-vida-corp'
                    subTitulo={{ __html: "Protegé a tus empleados, ante circunstancias imprevistas como accidente, enfermedad o fallecimiento.<br/><br/>¿Empezamos?" }}
                />
                <div className="pt-70 pt-lg-80 pb-40 bg-primary position-relative">
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Este seguro está diseñado para llevar tranquilidad a tus empleados y sus beneficiarios, proporciona protección financiera en caso de fallecimiento u incapacidad laboral. En un seguro de vida corporativo, la empresa es el tomador de la póliza y generalmente paga las primas correspondientes. Los empleados son los asegurados y, en caso de fallecimiento, los beneficiarios designados recibirán la indemnización.
                            </p>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Dentro de las principales coberturas, se incluyen:
                            </p>
                        </div>

                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Coberturas por accidente:</b> invalidez parcial permanente, invalidez total permanente, fallecimiento en cualquier parte del mundo.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Coberturas extra:</b> Sepelio, enfermedades graves.
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Formulario
                    rubro='Vida'
                    titulo='Cotizá seguro de Vida Corporativa'
                />
                <PorQueElegirnos />
                <PropuestaValor />
                {/* <Asesoramiento /> */}
            </div>
        </>
    )
}
